// src/flags/waffleFlag.ts
var WaffleFlag = /* @__PURE__ */ ((WaffleFlag2) => {
  WaffleFlag2["AlchemyarbFam"] = "alchemyarb-fam-allowlist";
  WaffleFlag2["AlchemyarbSepolia"] = "alchemyarb-sepolia-allowlist";
  WaffleFlag2["AlchemyInternal"] = "alchemy-internal";
  WaffleFlag2["AlchemyMainnet"] = "alchemy-mainnet";
  WaffleFlag2["AlchemySepolia"] = "alchemy-sepolia";
  WaffleFlag2["AllowSignUpThroughBillingService"] = "allow_sign_up_through_billing_service";
  WaffleFlag2["AnimeMainnet"] = "anime-mainnet-allowlist";
  WaffleFlag2["AnimeTestnet"] = "anime-sepolia-allowlist";
  WaffleFlag2["ApexMainnet"] = "apex-mainnet-allowlist";
  WaffleFlag2["ArbNova"] = "arb-nova";
  WaffleFlag2["AvaxFuji"] = "avax-fuji-allowlist";
  WaffleFlag2["AvaxMainnet"] = "avax-mainnet-allowlist";
  WaffleFlag2["BerachainBArtio"] = "berachain-bartio-allowlist";
  WaffleFlag2["BerachainBepolia"] = "berachain-bepolia-allowlist";
  WaffleFlag2["Billing2GasManager"] = "enable_billing_2_gas_manager";
  WaffleFlag2["BNBMainnet"] = "bnb-mainnet-allowlist";
  WaffleFlag2["BNBTestnet"] = "bnb-testnet-allowlist";
  WaffleFlag2["BOBMainnet"] = "bob-mainnet-allowlist";
  WaffleFlag2["BOBSepolia"] = "bob-sepolia-allowlist";
  WaffleFlag2["BossMainnet"] = "boss-mainnet-allowlist";
  WaffleFlag2["BitcoinMainnet"] = "bitcoin-mainnet-allowlist";
  WaffleFlag2["BitcoinTestnet"] = "bitcoin-testnet-allowlist";
  WaffleFlag2["BitcoinSignet"] = "bitcoin-signet-allowlist";
  WaffleFlag2["Celo"] = "celo";
  WaffleFlag2["ChilizMainnet"] = "chiliz-mainnet-allowlist";
  WaffleFlag2["ChilizSpicy"] = "chiliz-spicy-allowlist";
  WaffleFlag2["DegenSepolia"] = "degen-sepolia-allowlist";
  WaffleFlag2["DontUseStrErrorFilter"] = "dont_use_str_error_filter";
  WaffleFlag2["EthHoodi"] = "eth-hoodi-allowlist";
  WaffleFlag2["EthMekong"] = "eth-mekong-allowlist";
  WaffleFlag2["Fantom"] = "fantom";
  WaffleFlag2["GasPump"] = "gas-pump";
  WaffleFlag2["GasManagerPredeposit"] = "gas-manager-predeposit";
  WaffleFlag2["GeistMainnet"] = "geist-mainnet-allowlist";
  WaffleFlag2["GensynTestnet"] = "gensyn-testnet-allowlist";
  WaffleFlag2["Gnosis"] = "gnosis";
  WaffleFlag2["HumanityMainnet"] = "humanity-mainnet-allowlist";
  WaffleFlag2["HumanityTestnet"] = "humanity-testnet-allowlist";
  WaffleFlag2["IotaMainnet"] = "iota-mainnet-allowlist";
  WaffleFlag2["IotaTestnet"] = "iota-testnet-allowlist";
  WaffleFlag2["K2Testnet"] = "k2-testnet-allowlist";
  WaffleFlag2["KintoMainnet"] = "kinto-mainnet-allowlist";
  WaffleFlag2["LensMainnet"] = "lens-mainnet-allowlist";
  WaffleFlag2["Linea"] = "linea";
  WaffleFlag2["MetabasedStratos"] = "metabased-stratos-allowlist";
  WaffleFlag2["MetisMainnet"] = "metis-mainnet-allowlist";
  WaffleFlag2["ModeMainnet"] = "mode-mainnet-allowlist";
  WaffleFlag2["ModeSepolia"] = "mode-sepolia-allowlist";
  WaffleFlag2["MoonbaseAlpha"] = "moonbase-alpha-allowlist";
  WaffleFlag2["MoonbeamMainnet"] = "moonbeam-mainnet-allowlist";
  WaffleFlag2["MoonriverMainnet"] = "moonriver-mainnet-allowlist";
  WaffleFlag2["OdysseySepolia"] = "odyssey-sepolia-allowlist";
  WaffleFlag2["opBNB"] = "opbnb";
  WaffleFlag2["PalmMainnet"] = "palm-mainnet-allowlist";
  WaffleFlag2["PalmTestnet"] = "palm-testnet-allowlist";
  WaffleFlag2["Pipelines"] = "allow_data_platform";
  WaffleFlag2["PlumeTestnet"] = "plume-testnet-allowlist";
  WaffleFlag2["RaasDashboard"] = "enable_raas_dashboard";
  WaffleFlag2["RaasSelfServe"] = "enable_raas_self_serve";
  WaffleFlag2["RaceMainnet"] = "race-mainnet-allowlist";
  WaffleFlag2["RaceTestnet"] = "race-sepolia-allowlist";
  WaffleFlag2["RoninMainnet"] = "ronin-mainnet-allowlist";
  WaffleFlag2["RoninSaigon"] = "ronin-saigon-allowlist";
  WaffleFlag2["Scroll"] = "scroll";
  WaffleFlag2["SettlusMainnet"] = "settlus-mainnet-allowlist";
  WaffleFlag2["ShidenMainnet"] = "shiden-mainnet-allowlist";
  WaffleFlag2["ShidenShibuya"] = "shiden-shibuya-allowlist";
  WaffleFlag2["SocialLoginForAccounts"] = "enable_social_login_for_accounts";
  WaffleFlag2["SoneiumMinato"] = "soneium-minato-allowlist";
  WaffleFlag2["SparkpointMainnet"] = "sparkpoint-mainnet-allowlist";
  WaffleFlag2["SparkpointTestnet"] = "sparkpoint-testnet-allowlist";
  WaffleFlag2["SpotlightMainnet"] = "spotlight-mainnet-allowlist";
  WaffleFlag2["SpotlightSepolia"] = "spotlight-sepolia-allowlist";
  WaffleFlag2["StandardMainnet"] = "standard-mainnet-allowlist";
  WaffleFlag2["StandardTestnet"] = "standard-testnet-allowlist";
  WaffleFlag2["StoryMainnet"] = "story-mainnet-allowlist";
  WaffleFlag2["StoryAeneid"] = "story-aeneid-allowlist";
  WaffleFlag2["SuperseedMainnet"] = "superseed-mainnet-allowlist";
  WaffleFlag2["SuperseedSepolia"] = "superseed-sepolia-allowlist";
  WaffleFlag2["SyndicateExo"] = "syndicate-exo-allowlist";
  WaffleFlag2["TeaMainnet"] = "tea-mainnet-allowlist";
  WaffleFlag2["TeaSepolia"] = "tea-sepolia-allowlist";
  WaffleFlag2["UniteMainnet"] = "unite-mainnet-allowlist";
  WaffleFlag2["UniteTestnet"] = "unite-testnet-allowlist";
  WaffleFlag2["XprotocolMainnet"] = "xprotocol-mainnet-allowlist";
  WaffleFlag2["XprotocolSepolia"] = "xprotocol-sepolia-allowlist";
  WaffleFlag2["AlterscopeMainnet"] = "alterscope-mainnet-allowlist";
  WaffleFlag2["AlterscopeSepolia"] = "alterscope-sepolia-allowlist";
  WaffleFlag2["OpenlootSepolia"] = "openloot-sepolia-allowlist";
  WaffleFlag2["RiseTestnet"] = "rise-testnet-allowlist";
  WaffleFlag2["MarsTestnet"] = "mars-testnet-allowlist";
  WaffleFlag2["EarnmSepolia"] = "earnm-sepolia-allowlist";
  WaffleFlag2["WylerchainSepolia"] = "wylerchain-sepolia-allowlist";
  return WaffleFlag2;
})(WaffleFlag || {});

export {
  WaffleFlag
};
//# sourceMappingURL=chunk-KJCBMFS7.mjs.map